// removed by extract-text-webpack-plugin
module.exports = {"userrequest":"userrequest___73Q9V","userrequest_comments":"userrequest_comments___1eS3-","userrequest_summary":"userrequest_summary___1X0zo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Userrequest/Userrequest.module.scss
// module id = 2377
// module chunks = 0